import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import GIF from "../../images/services-usa/saas-video/stellar.gif";
import { Link } from "gatsby";

function Stellartypes() {
  return (
    <section className="stellar_types p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              3 Stellar Types of <span>SaaS Videos</span>
            </h2>
            <p>
              B2B SaaS videos make your product look fun, and exciting. It’s the
              most breathtaking visual sales pitch. It’s like a walkthrough of
              the entire product in the virtual world. Made to spark with
              spell-binding animation, we produce three stellar types of SaaS
              videos.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <div className="stellar_img">
              <img src={GIF} alt="TekRevol" />
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
            <div className="stellar_box">
              <div className="stellar_head">
                <h3>
                  SaaS Product
                  <br /> Videos
                </h3>
              </div>
              <div className="stellar_content">
                <p>
                  Product demo video production is a thrilling way to get the
                  noise around your SaaS product prior its blockbuster launch.
                  You can think of these colorful, creative, compelling, yet
                  spot-on ads made to speak to your prospect in a
                  customer-centric style. You can do an overview as well as a
                  series of short ads to pique curiosity of your audience.
                </p>
              </div>
              {/* <div className="stellar_arrow">{SassArrow}</div> */}
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
            <div className="stellar_box">
              <div className="stellar_head">
                <h3>
                  SaaS Explainer
                  <br /> Videos
                </h3>
              </div>
              <div className="stellar_content">
                <p>
                  SaaS explainer videos are wildly popular today. These videos
                  introduce your prospect to your product with a riveting story,
                  helping them grasp value in a matter of seconds. It highlights
                  pain points, and teases the solution in a mesmerizing fashion.
                </p>
              </div>
              {/* <div className="stellar_arrow">{SassArrow}</div> */}
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="my-auto">
            <div className="stellar_box">
              <div className="stellar_head">
                <h3>
                  SaaS Marketing
                  <br /> Videos
                </h3>
              </div>
              <div className="stellar_content">
                <p>
                  How about creating a product demo for your SaaS tool? SaaS
                  marketing videos are made for a number of specific use cases.
                  Your prospects will discover amazing SaaS functionality, and
                  get familiar with the cool interface, one-step at a time.
                </p>
              </div>
              {/* <div className="stellar_arrow">{SassArrow}</div> */}
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Lets Connect
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Stellartypes;
